import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { FiTwitter } from 'react-icons/fi';

function HeaderSocials() {
    return (
        <div className='header__socials'>
            <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/felix-ntougan/" >
                <BsLinkedin />
            </a>
            <a target="_blank" rel="noreferrer" href="https://github.com/Felix-fale" >
                <FaGithub />
            </a>
            <a target="_blank" rel="noreferrer" href="https://twitter.com/Felix_Fale" >
                <FiTwitter />
            </a>
        </div>
    );
}

export default HeaderSocials;